var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacilityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1318 13L8.73184 5.65L4.75684 11.125L0.131836 7.5V4L4.13184 7L9.13184 0L14.1318 4H18.1318V13ZM0.131836 17V10L5.13184 14L9.13184 8.5L18.1318 15.525V17H0.131836Z",
    fill: "#D58DE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon);
export default __webpack_public_path__ + "static/media/facility_icon.8c0598e568c1c3295e56ae90fa3a1db2.svg";
export { ForwardRef as ReactComponent };